var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbolCssShort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666016 30.2344C0.666016 13.6658 14.0975 0.234375 30.666 0.234375H90.666C107.235 0.234375 120.666 13.6658 120.666 30.2344V90.2344C120.666 106.803 107.235 120.234 90.666 120.234H30.666C14.0975 120.234 0.666016 106.803 0.666016 90.2344V30.2344Z",
    fill: "url(#paint0_linear_219_4772)",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.416 30.2344L39.1973 84.2344L60.666 90.2344L82.1273 84.2381L86.916 30.2344H34.416ZM74.271 75.0169L60.666 78.7744L60.6585 78.7781L47.0648 75.0131L46.1123 64.3781H52.7723L53.2673 69.8981L60.6585 71.8931L60.666 71.8856L68.0648 69.8906L69.0735 60.6994L45.7935 60.7631L45.1335 54.4744L69.6323 54.1894L70.1273 47.4581L44.4773 47.5294L44.046 41.2744H77.286L74.271 75.0169Z",
    fill: "url(#paint1_linear_219_4772)",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_219_4772",
    x1: 60.666,
    y1: 0.234375,
    x2: 60.666,
    y2: 120.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_219_4772",
    x1: 60.666,
    y1: 30.2344,
    x2: 60.666,
    y2: 90.2344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.6
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolCssShort);
export default __webpack_public_path__ + "static/media/symbol-css-short.8023c1b2efb58053dd97ac9d48027d64.svg";
export { ForwardRef as ReactComponent };